<div class="watchlist-companies-table card">
  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container">
    <div class="spinner"></div>
    <p>Loading companies...</p>
  </div>

  <!-- Empty State -->
  <div *ngIf="!loading && companies.length === 0 && !isReadOnly" class="empty-state">
    <div class="empty-icon">
      <i class="bi bi-building"></i>
    </div>
    <h3>No companies in this watchlist</h3>
    <p>Add companies to start monitoring their innovation scores and rankings.</p>
  </div>

  <!-- Table Content -->
  <div *ngIf="!loading && companies.length > 0" class="table-container">
    <div class="table-header">
  
      <div class="search-container">
        <input 
          type="text" 
          class="form-control search-input" 
          placeholder="Search companies..." 
          [(ngModel)]="searchQuery"
          (ngModelChange)="applyFilters()">
      </div>
      <div class="table-actions">
        <!-- <button class="btn btn-outline-secondary btn-sm" (click)="exportData()">
          <i class="bi bi-download"></i> Export
        </button> -->
        <button class="btn search-button" style="margin-left:20px;" (click)="downloadExcel()" [disabled]="loading || companies.length === 0"
        matTooltip="Download Excel">
        <i class="bi bi-download"></i>
      </button>
      </div>
    </div>


  </div>
  <div class="table-wrapper">

    <table class="table table-hover table-condensed" *ngIf="!loading && companies.length > 0">

      <thead>
        <tr style="background-color: #96c242;">
          <th scope="col" style="width: 15%;">Company</th>
          <th scope="col" style="width: 10%;">
            <div class="dropdown" style=" font-weight:normal;
">
              <button class="btn country-dropdown-btn dropdown-toggle" type="button" id="dropdownMenuButton"
                data-bs-toggle="dropdown" aria-expanded="false" >
                Country / <br>Market
              </button>

              <div class="dropdown-menu p-3" aria-labelledby="dropdownMenuButton"
                style="width: 270px; max-height: 300px; overflow-y: auto;">
                <!-- Loop through each region -->
                <div *ngFor="let region of countryFilterOptions">
                  <!-- Region Header -->
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <input type="checkbox" [checked]="isRegionFullySelected(region)"
                        (change)="toggleRegionSelection(region)" id="{{ region.region }}-region-checkbox"
                        class="form-check-input me-2">
                      <label for="{{ region.region }}-region-checkbox" class="form-check-label">
                        {{ region.region }}
                      </label>
                    </div>
                    <button class="btn btn-sm btn-light"
                      (click)="toggleExpand(region.region); $event.stopPropagation();">
                      <i class="bi" [ngClass]="isExpanded(region.region) ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                    </button>
                  </div>
                  <!-- Countries in the Region -->
                  <div *ngIf="isExpanded(region.region)" class="ms-3">
                    <div *ngFor="let country of region.countries" class="form-check">
                      <input type="checkbox" class="form-check-input" [id]="'country-' + country.code"
                        [checked]="(countriesControl.value ?? []).includes(country.code)"
                        (change)="toggleCountrySelection(country.code, region)">
                      <label class="form-check-label" [for]="'country-' + country.code">
                        {{ country.name }}
                      </label>
                    </div>
                  </div>
                  <hr class="my-2" *ngIf="region !== countryFilterOptions[countryFilterOptions.length - 1]">
                </div>
              </div>
            </div>



          </th>

          <th scope="col" style="width: 15%;">
            <div class="dropdown" style="font-weight:normal;">
              <button class="btn gics-dropdown-btn dropdown-toggle" type="button" id="gicsDropdownMenuButton"
                data-bs-toggle="dropdown" aria-expanded="false" >
                GICS Peer Group
                <i class="bi bi-info-circle" 
               matTooltip="Higher level GICS classifications are used when the sub-industry classification contains less than 50 members."
               style="margin-left: 5px; color: #000000; cursor: pointer; font-size: 16px;"></i>

              </button>

              <div class="dropdown-menu p-3" aria-labelledby="gicsDropdownMenuButton"
                style="width: 300px; max-height: 300px; overflow-y: auto;">
                <div *ngFor="let subindustry of gicsSubindustryOptions" class="form-check">
                  <input type="checkbox" class="form-check-input" [id]="'gics-' + subindustry"
                    [checked]="(gicsSubindustryControl.value ?? []).includes(subindustry)"
                    (change)="toggleGicsSubindustrySelection(subindustry)">
                  <label class="form-check-label" [for]="'gics-' + subindustry">
                    {{ subindustry }}
                  </label>
                </div>
              </div>
            </div>
          </th>
          <th scope="col" style="width: 15%;" class="sortable" (click)="sort('innovation_score')" [class.sorted-col]="sortColumn==='innovation_score'">
            Innovation Score 
            <i class="bi bi-info-circle" 
               matTooltip="Current Innovation Score of the company relative to its GICS Peer Group." 
               style="margin-left: 5px; color: #000000; cursor: pointer; font-size: 16px;"></i>
            <i class="bi sort-icon" [ngClass]="getSortIcon('innovation_score')"></i>
          </th>
          <th scope="col" style="width: 12%;" class="sortable" (click)="sort('score_change')" [class.sorted-col]="sortColumn==='score_change'">
            Score Change (3 months) 
            <i class="bi bi-info-circle" 
               matTooltip="Change in Innovation Score in the last 3 months." 
               style="margin-left: 5px; color: #000000; cursor: pointer; font-size: 16px;"></i>
            <i class="bi" [ngClass]="getSortIcon('score_change')"></i>
          </th>
          <th scope="col" style="width: 12%;">
            Rank in Peer Group
            <i class="bi bi-info-circle" 
               matTooltip="Current Rank of the company in its GICS Peer Group." 
               style="margin-left: 5px; color: #000000; cursor: pointer; font-size: 16px;"></i>
          </th>
          <th scope="col" style="width: 11%;" class="sortable" (click)="sort('rank_change')" [class.sorted-col]="sortColumn==='rank_change'">
            Rank Change (%, 3 months) 
            <i class="bi bi-info-circle" 
               matTooltip="Percentile ranks climbed by the company in the last 3 months." 
               style="margin-left: 5px; color: #000000; cursor: pointer; font-size: 16px;"></i>
            <i class="bi" [ngClass]="getSortIcon('rank_change')"></i>
          </th>
          <th style="width: 10%;"> Action</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let company of filteredCompanyList | paginate: {id:'pag_watchlist_companies_table', itemsPerPage: 10, currentPage: paginator_page } ; trackBy: trackByEntityId">
          <td  scope="col" style="width: 15%;">
            <div class="text" style="max-width: 200px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            " matTooltip="{{company.entity_name}}">
              {{ company.entity_name }}
            </div>
            <div class="isin" *ngIf="company.isin" style="font-size: 12px;color: cadetblue;">
              {{company.isin}} <a *ngIf="company.webpage"
                [href]="company.webpage && company.webpage.startsWith('http') ? company.webpage : (company.webpage ? 'http://' + company.webpage : '#')"
                target="_blank">
                <i class="bi bi-globe2" style="color: grey;"></i>
              </a>
            </div>
            <div class="isin" *ngIf="!company.isin" style="font-size: 12px;color: cadetblue;">
              {{company.companytype}} <a *ngIf="company.webpage"
                [href]="company.webpage && company.webpage.startsWith('http') ? company.webpage : (company.webpage ? 'http://' + company.webpage : '#')"
                target="_blank">
                <i class="bi bi-globe2" style="color: grey;"></i>
              </a>
            </div>
          </td>
          <td  scope="col" style="width: 10%;">{{ company.country }}</td>
          <td  scope="col" style="width: 15%;">
            <!-- Hover text: Pharmaceuticals (level name) -->
            <div class="text" style="
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            " matTooltip="{{company.gics_custom_name || company.gsubind_extended_name || company.subindustryname}} ({{getIndustryLevel(company.gics_custom_level)}}: GICS Level {{company.gics_custom_level}} out of 4)">
              {{ company.gics_custom_name || company.gsubind_extended_name ||  company.subindustryname }}
            </div>
            <!-- {{ company.subindustryname || company.gsubind_extended_name }} -->
          </td>

          <td [class.sorted-col]="sortColumn==='innovation_score'" scope="col" style="width: 15%;">
            <div class="score-bar-container">
              <div class="score-bar">
                <div class="score-bar-fill" [ngClass]="getBarColor(company.innovation_score)"
                  [style.width.%]="company.innovation_score"></div>
              </div>
              <span class="score-label">{{ company.innovation_score | number: '1.0-1' }}</span>
            </div>

          </td>
          <td [class.sorted-col]="sortColumn==='score_change'" scope="col" style="width: 12%;">
            <div class="change-metric" 
                 *ngIf="company.innovation_score_change !== null && company.innovation_score_change !== undefined"
                 [ngClass]="getBracketColor(company.score_bracket)"
                 [matTooltip]="getBracketTooltip(company.score_bracket)"
                 [matTooltipDisabled]="!getBracketTooltip(company.score_bracket)">
              <i class="bi" [ngClass]="getBracketArrow(company.score_bracket)"></i>
              <span>
                <!-- display the + if the score_change is positive -->
                <span *ngIf="company.innovation_score_change > 0.4">+</span>
                {{company.innovation_score_change | number: '1.0-1' }}
              </span>
            </div>
          </td>
          <td scope="col" style="width: 12%;">
            <span style="font-weight: normal;">
              {{company.rank}}{{getOrdinalSuffix(company.rank)}}
            </span>
            <br>
            <span style="font-weight: normal;">(out of {{company.peer_group_size}})</span>

          </td>
          <td [class.sorted-col]="sortColumn==='rank_change'" scope="col" style="width: 11%;">
            <div class="change-metric" 
                 *ngIf="company.pct_rank_climbed !== null && company.pct_rank_climbed !== undefined"
                 [ngClass]="getBracketColor(company.rank_bracket)"
                 [matTooltip]="getBracketTooltip(company.rank_bracket)"
                 [matTooltipDisabled]="!getBracketTooltip(company.rank_bracket)">
              <i class="bi" [ngClass]="getBracketArrow(company.rank_bracket)"></i>
              <span class="value">
                <span [ngClass]="company.rank_bracket === 3 ? '' : 'font-weight-bold'"> 
                  <span *ngIf="company.pct_rank_climbed > 0.4">+</span>
                 {{company.pct_rank_climbed | number: '1.0-1' }}%
                </span><br>
                <span style="font-weight: normal;">
               ({{company.rank_climbed}} ranks)  
                </span>

              </span>
            </div>
        
          </td>
          <td scope="col" style="width: 10%;">
            <button class="btn" (click)="newSearch(company)" matTooltip="View Company"
              [disabled]="!(company.gsubind_extended || company.gsubind)" style="background: linear-gradient(135deg, #b39cd0 0%, #7c6bb8 100%);">
              <i class="bi bi-box-arrow-up-right" style="color: rgb(255, 255, 255);font-size: 18px;"></i>
            </button>
            <!-- delete from watchlist (only for watchlists, not benchmarks) -->
            <button class="btn" (click)="deleteFromWatchlist(company)" *ngIf="!isReadOnly && !isReadOnly" style="background: linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%); color: #666; margin-left: 10px;" matTooltip="Delete from Watchlist">
              <i class="bi bi-trash" style="color: #666; font-size: 18px;"></i>
            </button>
          </td>

        </tr>
      </tbody>
    </table>

    <pagination-controls id="pag_watchlist_companies_table" [maxSize]="10" (pageChange)="paginator_page = $event"
      style="align-items: flex-start;" *ngIf="companies.length>0">
    </pagination-controls>
  </div>
</div>